import React from 'react';
import classnames from 'classnames';

import './input-select.scss';

const sortSequenceOrder = data => {
  let Temp = [
    ...data,
  ];
  Temp.sort((a, b) => a.sequence - b.sequence);
  return Temp;
};

class SliderSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      valueChanged: !!(props.defaultValue),
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
  }

  handleDisplay() {
    this.setState({
      valueChanged: true,
    });
  }

  handleOnChange(event) {
    if (this.props.onChange) {
      const OptionIndex = parseInt(event.target.value, 10) - 1;
      const Option = sortSequenceOrder(this.props.field.field_options)[OptionIndex];
      const value = OptionIndex === -1 ? "0" : Option.option_value; 

      this.props.onChange({
        target: {
          value,
        }
      });
    }
  }

  getDefault(value) {
    const OptionIndex = sortSequenceOrder(this.props.field.field_options).findIndex(Option => Option.option_value === value);
    if (OptionIndex !== -1) {
      return OptionIndex + 1;
    }

    return null;
  }

  render() {
    const options  = this.props.field.field_options;

    return (
      <div className={classnames({
        'SliderSelect': true,
        'SliderSelect--inactive': this.state.valueChanged === false,
      })}>
        <input type="range" className="Form__Input--Range" onClick={this.handleDisplay} step={1} min={0} onChange={this.handleOnChange}
          max={options.length}
          defaultValue={this.getDefault(this.props.defaultValue) || 0}
          style={{
            paddingLeft: (45 / (options.length+1) + '%'),
            paddingRight: (45 / (options.length+1) + '%'),
          }} />
        <div className="row" style={{ margin: '0' }}>
          <p className="SliderSelect__Label" style={{
              width: 100 / (options.length+1) + '%',
            }}>N/A<br/>(No feedback)</p>
          {sortSequenceOrder(options).map(option => (
            <div key={'Option__' + option.id} style={{
              width: 100 / (options.length+1) + '%',
            }}>
              {option.option_value.split(' (').map((StringVal, Index) => {
                if (Index === 0) {
                  return (
                    <p key={Index} className="SliderSelect__Label">{StringVal}</p>
                  );
                } else {
                  return (
                    <p key={Index} className="SliderSelect__Label">{'(' + StringVal}</p>
                  );
                }
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default SliderSelect;



// WEBPACK FOOTER //
// ./src/routes/modules/routes/ViewComponent/components/ComponentWrapper/inputs/slider-select.js